import type { Contract } from "@/generated/types";
import ContractCard from "./ContractCard";
import EmptyContractsState from "./EmptyContractsState";
import ContractsListSkeleton from "./ContractsListSkeleton";

interface ContractsListProps {
  contracts: Contract[];
  loading?: boolean;
}

export default function ContractsList({ contracts, loading }: ContractsListProps) {
  if (loading) {
    return <ContractsListSkeleton />;
  }

  if (contracts.length === 0) {
    return <EmptyContractsState />;
  }

  return (
    <div className="space-y-4">
      {contracts.map((contract) => (
        <ContractCard key={contract.id} contract={contract} />
      ))}
    </div>
  );
}
